import { AppSession } from '@prisma/client'
import { AppSessionType } from '../common'
import { AppSessionFormValues } from './types'

export const getValue = (appSession: AppSession, key: string) => {
  const values = appSession.values

  return key.split('.').reduce((acc, key) => acc?.[key], values)
}

export const getOnboardingValues = (
  appSession: AppSession,
): AppSessionFormValues => {
  const values: AppSessionFormValues =
    (appSession.values as any)?.onboarding ?? {}

  return {
    ...values,
  }
}

export const isOnboarded = (appSession: AppSessionType) => {
  return appSession?.role
}

export const getUIFormValues = (
  appSession: AppSession,
): AppSessionFormValues => {
  const values: AppSessionFormValues = (appSession.values as any)?.uiForm ?? {}

  return {
    ...values,
  }
}

const getName = (appSession: AppSessionType) => {
  return appSession?.name
}

const getPictureUrl = (appSession: AppSessionType) => {
  return appSession?.pictureUrl
}

const getRole = (appSession: AppSessionType) => {
  return appSession?.role
}

export const Helper = {
  getOnboardingValues,
  getUIFormValues,
  getPictureUrl,
  getName,
  getRole,
  getValue,
}
